import ConsumerGroup from './ConsumerGroup';

export default ConsumerGroup;
